import { render, staticRenderFns } from "./BankTransactionReport.vue?vue&type=template&id=3152a054&scoped=true&"
import script from "./BankTransactionReport.vue?vue&type=script&lang=js&"
export * from "./BankTransactionReport.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactionReport.vue?vue&type=style&index=0&id=3152a054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152a054",
  null
  
)

export default component.exports